import React, { useEffect, useState } from 'react';
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  Paper,
} from '@mui/material';

import { toast } from 'sonner';
import { fetchKpiYear } from '../../api/kpiApi';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

const colors = {
  green: '#4CAF50',
  orange: '#FFC107',
  red: '#F44336',
};

const parameters = [
  {
    name: '% OCC RECOVERED',
    competency: '≥ 80%',
    benchmark: '≥ 95%',
    key: 'occRecovered',
    color: (value) =>
      value >= 95 ? colors.green : value >= 80 ? colors.orange : colors.red,
  },
  {
    name: 'MATURATION RATE',
    competency: '≥ 75%',
    benchmark: '≥ 90%',
    key: 'maturationRate',
    color: (value) =>
      value >= 90 ? colors.green : value >= 75 ? colors.orange : colors.red,
  },
  {
    name: 'ICSI NORMAL FERT. RATE',
    competency: '≥ 65%',
    benchmark: '≥ 80%',
    key: 'isciNormalRate',
    color: (value) =>
      value >= 80 ? colors.green : value >= 65 ? colors.orange : colors.red,
  },
  {
    name: 'ICSI DAMAGE RATE',
    competency: '≤ 10%',
    benchmark: '≤ 5%',
    key: 'isciDamageRate',
    color: (value) =>
      value <= 5 ? colors.green : value <= 10 ? colors.orange : colors.red,
  },
  {
    name: '1PN rate (ICSI)',
    competency: '',
    benchmark: '< 3',
    key: 'isciOnePnRate',
    color: (value) => (value <= 3 ? colors.green : colors.red),
  },
  {
    name: 'IVF NORMAL FERT. RATE',
    competency: '≥ 60%',
    benchmark: '≥ 75%',
    key: 'ivfNormalRate',
    color: (value) =>
      value >= 75 ? colors.green : value >= 60 ? colors.orange : colors.red,
  },
  {
    name: 'IVF Polyspermy Rate ',
    competency: '',
    benchmark: '< 6',
    key: 'ivfPolyspermyRate',
    color: (value) => (value <= 6 ? colors.green : colors.orange),
  },
  {
    name: '1PN rate (IVF)',
    competency: '',
    benchmark: '< 5',
    key: 'ivfOnePnRate',
    color: (value) => (value <= 5 ? colors.green : colors.orange),
  },
  {
    name: 'Cleavage Rate',
    competency: '≥ 95',
    benchmark: '≥ 99',
    key: 'cleavageRate',
    color: (value) =>
      value >= 99 ? colors.green : value >= 95 ? colors.orange : colors.red,
  },
  {
    name: 'Day 3 Embryo Development Rate',
    competency: '≥ 45',
    benchmark: '≥ 70',
    key: 'day3DevelopmentRate',
    color: (value) =>
      value >= 70 ? colors.green : value >= 45 ? colors.orange : colors.red,
  },
  {
    name: 'Blastocyst Development Rate',
    competency: '≥ 40',
    benchmark: '≥ 60',
    key: 'blastocystDevelopmentRate',
    color: (value) =>
      value >= 60 ? colors.green : value >= 40 ? colors.orange : colors.red,
  },
  {
    name: 'Good Blastocyst Development Rate',
    competency: '≥ 30',
    benchmark: '≥ 40',
    key: 'goodBlastocystDevelopmentRate',
    color: (value) =>
      value >= 40 ? colors.green : value >= 30 ? colors.orange : colors.red,
  },
  {
    name: 'Blastocyst Cryo-Survival Rate',
    competency: '≥ 90',
    benchmark: '≥ 99',
    key: 'blastocystCryoRate',
    color: (value) =>
      value >= 99 ? colors.green : value >= 90 ? colors.orange : colors.red,
  },
  {
    name: 'Overall Survival Rate',
    competency: '≥ 85',
    benchmark: '≥ 95',
    key: 'overallSurvivalRate',
    color: (value) =>
      value >= 95 ? colors.green : value >= 85 ? colors.orange : colors.red,
  },
  {
    name: 'B-HCG POSITIVE Rate',
    competency: '≥ 50',
    benchmark: '≥ 65',
    key: 'bhcgPositiveRate',
    color: (value) =>
      value >= 65 ? colors.green : value >= 50 ? colors.orange : colors.red,
  },
  {
    name: 'Fresh ET B-HCG POSITIVE Rate',
    competency: '≥ 50',
    benchmark: '≥ 65',
    key: 'freshEtBhcgPositiveRate',
    color: (value) =>
      value >= 65 ? colors.green : value >= 50 ? colors.orange : colors.red,
  },
  {
    name: 'FET Biochemical Pregnancy Rate',
    competency: '≤ 10',
    benchmark: '≤ 5',
    key: 'fetBiochemicalPregnancyRate',
    color: (value) =>
      value <= 5 ? colors.green : value <= 10 ? colors.orange : colors.red,
  },
  {
    name: 'OPU Biochemical Pregnancy Rate',
    competency: '≤ 10',
    benchmark: '≤ 5',
    key: 'opuBiochemicalPregnancyRate',
    color: (value) =>
      value <= 5 ? colors.green : value <= 10 ? colors.orange : colors.red,
  },
  {
    name: 'FET Implantation Rate (Cleavage Stage)',
    competency: '≥ 25',
    benchmark: '≥ 35',
    key: 'fetImplantationRateCleavage',
    color: (value) =>
      value >= 35 ? colors.green : value >= 25 ? colors.orange : colors.red,
  },
  {
    name: 'FET Implantation Rate (Blastocyst Stage)',
    competency: '≥ 35',
    benchmark: '≥ 60',
    key: 'fetImplantationRateBlastocyst',
    color: (value) =>
      value >= 60 ? colors.green : value >= 35 ? colors.orange : colors.red,
  },
  {
    name: 'OPU Implantation Rate (Cleavage Stage)',
    competency: '≥ 25',
    benchmark: '≥ 35',
    key: 'opuImplantationRateCleavage',
    color: (value) =>
      value >= 35 ? colors.green : value >= 25 ? colors.orange : colors.red,
  },
  {
    name: 'OPU Implantation Rate (Blastocyst Stage)',
    competency: '≥ 35',
    benchmark: '≥ 60',
    key: 'opuImplantationRateBlastocyst',
    color: (value) =>
      value >= 60 ? colors.green : value >= 35 ? colors.orange : colors.red,
  },
  {
    name: 'FET Clinical Pregnancy Rate',
    competency: '≥ 40',
    benchmark: '≥ 50',
    key: 'fetClinicalPregnancyRate',
    color: (value) =>
      value >= 50 ? colors.green : value >= 40 ? colors.orange : colors.red,
  },
  {
    name: 'OPU-Fresh Clinical Pregnancy Rate',
    competency: '≥ 40',
    benchmark: '≥ 50',
    key: 'opuFreshClinicalPregnancyRate',
    color: (value) =>
      value >= 50 ? colors.green : value >= 40 ? colors.orange : colors.red,
  },
  {
    name: 'Sperm motility post-preparation (for IUI) ',
    competency: '90',
    benchmark: '≥ 95',
    key: 'spermMotility',
    color: (value) =>
      value >= 95 ? colors.green : value >= 90 ? colors.orange : colors.red,
  },
];

const emptyColumn = {
  occRecovered: 0,
  maturationRate: 0,
  isciNormalRate: 0,
  isciDamageRate: 0,
  isciOnePnRate: 0,
  ivfNormalRate: 0,
  ivfPolyspermyRate: 0,
  ivfOnePnRate: 0,
  cleavageRate: 0,
  day3DevelopmentRate: 0,
  blastocystDevelopmentRate: 0,
  goodBlastocystDevelopmentRate: 0,
  blastocystCryoRate: 0,
  overallSurvivalRate: 0,
  bhcgPositiveRate: 0,
  freshEtBhcgPositiveRate: 0,
  fetBiochemicalPregnancyRate: 0,
  opuBiochemicalPregnancyRate: 0,
  fetImplantationRateCleavage: 0,
  fetImplantationRateBlastocyst: 0,
  opuImplantationRateCleavage: 0,
  opuImplantationRateBlastocyst: 0,
  fetClinicalPregnancyRate: 0,
  opuFreshClinicalPregnancyRate: 0,
  spermMotility: 0,
};

export default function KpiComparison({ setCompareYears }) {
  const [columns, setColumns] = useState([{ ...emptyColumn }]);
  const [years, setYears] = useState([dayjs().year()]);
  const fetchYear = (year, index) => {
    toast.promise(
      fetchKpiYear(year).then((response) => {
        if (response.data.length === 0) {
          toast.error('No data found for the selected date range');
        } else {
          const copyColums = [...columns];
          copyColums[index] = response.data[0];
          setColumns(copyColums);
        }
      }),
      {
        loading: 'Loading ...',
        success: 'Data loaded',
        error: 'Failed to load data',
      },
    );
  };

  const onYearChange = (year, index) => {
    if (year && year !== 0) {
      const copyYears = [...years];
      copyYears[index] = year;
      setYears(copyYears);
      fetchYear(year, index);
    }
  };

  const addEmptyColumn = () => {
    setYears([...years, null]);
    setColumns([...columns, { ...emptyColumn }]);
  };

  useEffect(() => {
    const now = dayjs();
    const year = now.year();
    fetchYear(year, 0);
  }, []);

  return (
    <div className="theme-blush component-wrapper">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <button
            className="btn btn-primary ml-2"
            onClick={() => {
              addEmptyColumn();
            }}
          >
            Add More To Compare
          </button>
        </div>

        <button
          className="btn btn-primary ml-2"
          onClick={() => {
            setCompareYears(false);
          }}
        >
          Back
        </button>
      </div>

      <TableContainer component={Paper}>
        <Table style={{ tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '120px' }}>
                <strong>Parameter</strong>
              </TableCell>
              <TableCell style={{ width: '120px' }}>
                <strong>Competency</strong>
              </TableCell>
              <TableCell style={{ width: '120px' }}>
                <strong>Benchmark</strong>
              </TableCell>

              {columns.map((column, index) => (
                <TableCell key={column.id}>
                  <DatePicker
                    picker="year"
                    value={years[index] ? dayjs().year(years[index]) : null}
                    onChange={(date) => {
                      date && onYearChange(date.year(), index);
                    }}
                  />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {parameters.map((parameterGroup, index) => (
              <TableRow key={index}>
                <TableCell style={{ width: '20px' }}>
                  <strong>{parameterGroup.name}</strong>
                </TableCell>
                <TableCell style={{ width: '20px' }}>
                  <strong>{parameterGroup.competency}</strong>
                </TableCell>
                <TableCell style={{ width: '20px' }}>
                  <strong>{parameterGroup.benchmark}</strong>
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    style={{
                      backgroundColor: parameterGroup.color(
                        column[parameterGroup.key],
                      ),
                    }}
                  >
                    {column[parameterGroup.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
